<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }"  class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
              <h1 class="info-menu view-name">
                  <img src="static/img/assets/nav_rtfb_on.png" alt="">
                  <span v-if="this.$route.params.item">{{ $t('rtfbEditType') }}</span>
                  <span v-else>{{$t('rtfbRegisType')}}</span>
              </h1>
              <span class="info-right">
              </span>
          </div>
          <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <div class="ibox">
            <regist-public @delete-public-user="deletePublicUser" @delete-public-group="deletePublicGroup" @delete-public-org="deletePublicOrg" @reset-public="resetSelectPublic" @open-public="setDetail" :checkedUsers="this.checkedUsers" :checkedGroups="this.checkedGroups" :checkedOrgs="this.checkedOrgs"/>
            <div class="ibox-child">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label class="control-label">{{$t('contentsLabelTitle')}}</label>
                  <a v-b-modal.modal1 :class="{ 'image-uploaded' : uploadImage }" class="col-sm-1 add-photo" href="#"><i class="fa fa-picture-o"></i></a>
                  <span v-if="item.uploadedFile" class="image-add">
                    <a @click.stop target="blank" :href="item.uploadedFile">{{ $t('displayImgBtnTitle') }}</a>
                  </span>
                  <textarea v-model="item.contentText" class="form-control" :placeholder="$t('noDataStr')" rows="10"></textarea>
                  <span v-if="!$v.item.contentText.contentTextValidaiton" class="text-danger font-bold">{{$t('alertRequiredItemStr')}}</span>
                </div>
              </div>
            </div>
            <div class="ibox-child">
              <div class="row okr-regist-btnset">
                <div class="col-lg-4 col-md-4 col-sm-4"><button @click="senditem" type="button" class="btn btn-success block m-b" :disabled="checkRegistering" >{{$t('saveStr')}}</button></div>
                <div class="col-lg-4 col-md-4 col-sm-4"><button @click="cancelItem" type="button" class="btn btn-primary block m-b" :disabled="checkRegistering">{{$t('popTitleStr2Type')}}</button></div>
                <div class="col-lg-4 col-md-4 col-sm-4"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
              </div>
            </div>
          </div>
        </section>
        <b-modal id="modal1" :title="$t('changePictureStr')" :ok-title="$t('uploadPictureStr')" ref="modal" @hide="handleClickEvent">
          <div style="display: inline-block;">
            <toggle-button v-model="isEnableCrop"
              :labels= "isEnableCropToggleStr"
              :sync="true"
              :width="80"/>
            <span style="display: inline-block;">
              <label>
                <span class="btn btn-primary">
                  Choose Image<input type="file" accept='image/*' @change="onPictureSelected" style="display:none" v-if="flagForReset" ref="fileInputForm">
                </span>
              </label>
            </span>
            <span style="display: inline-block;">
              <button class="btn btn-danger" @click="removeCroppa">Delete Image</button>
            </span>
            <span style="display: inline-block">
              <button class="btn btn-secondary" style="background-color: gray" @click="rotateImage(-90)">
                <img :src="'static/img/assets/rotate_left_icon.png'" width="30" height="30">
              </button>
            </span>
            <span style="display: inline-block">
              <button class="btn btn-secondary" style="background-color: gray" @click="rotateImage(90)">
                <img :src="'static/img/assets/rotate_right_icon.png'" width="30" height="30">
              </button>
            </span>
          </div>
          <vue-cropper
                v-if="hasCropperImage"
                ref='cropper'
                :guides="true"
                :view-mode="2"
                :drag-mode="'crop'"
                :auto-crop-area="1.0"
                :zoomable="true"
                :min-container-width="300"
                :min-container-height="300"
                :background="true"
                :rotatable="true"
                :src="uploadImage"
                :img-style="{ 'width': '300px', 'height': '300px' }">
          </vue-cropper>
          <div v-if="!isLoaded" class="spinner" />

                 <!-- <input type="file" v-on:change="onFileChange"> -->
        </b-modal>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">{{$t('publicSettingLabelTitle')}}</span>
                <span class="info-right"></span>
              </div>
            <!-- Public -->
            <public-setting-detail-view v-if="detail == 'public'"
              :checkedOrgs="checkedOrgs"
              :checkedGroups="checkedGroups"
              :checkedUsers="checkedUsers"
              @updateGroups="onClickGroups"
              @updateOrganization="onClickOrg"
              @updateUsers="onClickUsers"
              ref="publicSetting"/>
          <!-- /Public  -->
            </div>
        </section>
      </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {storage} from '@/main'
import RegistPublic from '@/components/Regist/RegistPublic'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
import VueCropper from 'vue-cropperjs'
import PublicSettingDetailView from '@/components/DetailView/PublicSettingDetailView'

function contentTextValidaiton () {
  return this.item.contentText.trim().replace(/\r?\n/g, '').length !== 0
}

export default {
  name: 'FbRegist',
  mixedins: [validationMixin],
  components: {
    RegistPublic,
    VueCropper,
    PublicSettingDetailView
  },
  data: function () {
    return {
      tag: 'progress',
      open: false,
      detail: '',
      cropImage: '',
      isEnableCrop: false,
      myCroppa: {},
      uploadImage: '',
      isImage: false,
      flagForReset: true,
      searchText: '',
      groups: {},
      fileInfo: {},
      checkedGroups: [],
      checkedUsers: [],
      checkedOrgs: [],
      item: {
        contentText: '',
        // userIcon: '',
        userId: '',
        userName: '',
        limitedAccess: {},
        createdAt: ''
        // uploadedFile: ''
        // modifiedAt: ''
      },
      id: this.$route.params.id,
      checkDraft: false,
      isImageUploading: false,
      hasCropperImage: false,
      isRegistering: false,
      isLoaded: true
    }
  },
  validations: {
    item: {
      contentText: {
        contentTextValidaiton
      }
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'FbRegist'
    },
    checkRegistering: function () {
      if (this.uploadImage) {
        if (this.isRegistering) {
          console.log('no.1')
          return true
        }
        console.log('no.2')
        return false
      } else if (this.isImageUploading) {
        console.log('no.3')
        this.isImageUploading = false
        return true
      } else if (this.isRegistering) {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
        return true
      }
      console.log('no4')
      return false
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('rtfbs/', [
      'getCurrentDraftRtfbs'
    ]),
    ...mapGetters('groups/', [
      'getCurrentGroupsByText',
      'getOnlyGroupsBySearchText',
      'getGroupsByIds',
      'getCurrentGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserNameKeys',
      'getUsers'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    isEnableCropToggleStr () {
      return {
        checked: 'Edit ON',
        unchecked: 'Edit OFF',
        blank: 'ALL'
      }
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getUsers
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getOnlyOrganizationsByText('')
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    }
  },
  beforeMount: function () {
    this.groups = this.getGroups
    if (this.$route.params.item && this.$route.params.item.limitedAccess && this.$route.params.item.limitedAccess.limitedGroups) {
      this.checkedGroups = Object.keys(this.$route.params.item.limitedAccess.limitedGroups)
    }
  },
  watch: {
    isEnableCrop () {
      console.log('track:::', this.$refs.cropper, this.isEnableCrop)
      if (this.isEnableCrop) {
        if (this.$refs.cropper) {
          this.$refs.cropper.enable()
        }
      } else {
        if (this.$refs.cropper) {
          this.$refs.cropper.reset()
          this.$refs.cropper.disable()
        }
      }
    }
  },
  beforeUpdate: function () {
    if (this.getCurrentUserInfo) {
      if (this.getCurrentUserInfo.userIcon) {
        this.item.userIcon = this.getCurrentUserInfo.userIcon
      }
      this.item.userId = this.getUserId
      this.item.userName = this.getCurrentUserInfo.userName
    }
  },
  mounted: function () {
    console.log('fbregist mounted', this.$route.params.item)
    if (this.isRegistering) {
      this.isRegistering = false
    }
    if (this.$route.params.item) {
      this.item.contentText = this.$route.params.item.contentText
      this.item.createdAt = this.$route.params.item.createdAt
      if (this.$route.params.item.limitedAccess) {
        if (this.$route.params.item.limitedAccess.limitedUsers) {
          this.checkedUsers = Object.keys(this.$route.params.item.limitedAccess.limitedUsers)
        }
        if (this.$route.params.item.limitedAccess.limitedGroups) {
          let allGroups = this.getGroupsByIds(Object.keys(this.$route.params.item.limitedAccess.limitedGroups))
          let groupIds = Object.keys(allGroups).filter(x => !allGroups[x].isOrganization)
          let orgIds = Object.keys(allGroups).filter(x => allGroups[x].isOrganization)
          this.checkedGroups = groupIds
          this.checkedOrgs = orgIds
        }
      }
      if (this.$route.params.item.uploadedFile) {
        this.item.uploadedFile = this.$route.params.item.uploadedFile
        console.log(this.item)
      }
    } else if (Object.keys(this.getCurrentDraftRtfbs).filter(x => !this.getCurrentDraftRtfbs[x] ? false : this.getCurrentDraftRtfbs[x].contentText).length > 0) {
      this.$swal({
        title: this.$t('comfirmMakeFromDraftStr'),
        type: 'question',
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          console.log('true')
          const draftItem = this.getCurrentDraftRtfbs
          this.checkDraft = true
          // console.log(this.checkDraft)
          console.log('Object.keys(draftItem)', Object.keys(draftItem))
          for (let x of Object.keys(draftItem)) {
            // console.log(x)
            if (draftItem[x].contentText) {
              let item = this.item
              item.contentText = draftItem[x].contentText
              // ユーザーアイコンの有無を判別
              if (draftItem[x].userIcon) {
                item.userIcon = draftItem[x].userIcon
              }
              if (draftItem[x].uploadedFile) {
                item.uploadedFile = draftItem[x].uploadedFile
              }
              item.userId = draftItem[x].userId
              item.userName = draftItem[x].userName
              // item.limitedAccess.limitedUsers = draftItem[x].limitedAccess.limitedUsers
              // if (Object.keys(draftItem[x].limitedAccess).filter(x => x === 'limitedUsers').length > 0) {
              if (draftItem[x].limitedAccess.limitedAccess.limitedUsers) {
                this.checkedUsers = Object.keys(draftItem[x].limitedAccess.limitedUsers)
              }
              if (draftItem[x].limitedAccess.limitedGroups) {
                this.checkedGroups = Object.keys(draftItem[x].limitedAccess.limitedGroups)
              } else if (draftItem[x].limitedAccess.limitedGroup) {
                this.checkedGroups = Object.keys(draftItem[x].limitedAccess.limitedGroup)
              }
            }
          }
          // this.removeDraftsRtfbs(this.item)
          // this.removeDraftsRtfbs(this.getUserId)
        } else {
          console.log('false')
        }
      })
    }
  },
  updated: function () {
    // console.log(this.checkedGroup)
  },
  methods: {
    ...mapActions('rtfbs/', {
      setNewFbrequest: 'SET_NEW_FBREQUEST',
      setDraftsRtfbs: 'SET_DRAFTS_RTFBS',
      removeDraftsRtfbs: 'REMOVE_DRAFTS_RTFBS'
    }),
    resetSelectPublic: function () {
      this.checkedUsers = []
      this.checkedGroups = []
      this.checkedOrgs = []
      this.$refs.publicSetting.resetCheckings()
    },
    onClickGroups: function (value) {
      this.checkedGroups = value
    },
    onClickOrg: function (value) {
      this.checkedOrgs = value
    },
    onClickUsers: function (value) {
      this.checkedUsers = value
    },
    deletePublicUser: function (userId) {
      let targetIndex = this.checkedUsers.indexOf(userId)
      this.checkedUsers.splice(targetIndex, 1)
    },
    deletePublicGroup: function (groupId) {
      let targetIndex = this.checkedGroups.indexOf(groupId)
      this.checkedGroups.splice(targetIndex, 1)
    },
    deletePublicOrg: function (orgId) {
      let targetIndex = this.checkedOrgs.indexOf(orgId)
      this.checkedOrgs.splice(targetIndex, 1)
    },
    removeCroppa: function () {
      if (this.$refs.cropper) { this.$refs.cropper.destroy() }
      this.uploadImage = ''
      this.myCroppa.naturalWidth = 300
      this.myCroppa.naturalHeight = 300
      this.hasCropperImage = false
      this.isEnableCrop = false
      this.$refs.fileInputForm.value = null
      // this.$refs.modal.hide()
    },
    setDetail (value) {
      console.log('parent methods clear')
      this.detail = value
      if (this.open) {
        console.log('in if')
        this.open = false
      } else {
        console.log('in else')
        this.open = true
        console.log(this.open)
      }
    },
    // onClickGroupRadioButton (e) {
    //   console.log('checkedGroup, e', this.checkedGroups, e.target.value)
    //   if (e.target.value === this.checkedGroups) {
    //     this.checkedGroups = ''
    //   }
    // },
    handleImageRemove () {
      this.uploadImage = ''
      this.removeCroppa()
      this.hasCropperImage = false
    },
    // プロフィール画像プロップ処理
    onFileTypeMismatch () {
      const $t = this.$t
      this.$swal({
        text: $t('orderFileUploadStr'),
        type: 'warning',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        padding: '2rem',
        timer: 4000
      })
    },
    onFileSizeExceed (file) {
      const $t = this.$t
      this.$swal({
        text: $t('order2mbFileStr'),
        type: 'warning',
        animation: false,
        customClass: 'animated pulse'
      })
    },
    handleClickEvent: function (evt) {
      console.log(evt)
      const $t = this.$t
      if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && this.uploadImage) {
        evt.preventDefault()
        // sweetAlertに
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('confirmDeletePictureStr'),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 4000
        }).then((result) => {
          if (result.value) {
            this.removeCroppa()
            console.log('confirmDeletePictureStr -> true')
          } else {
            console.log('confirmDeletePictureStr -> false')
          }
        })
      } else if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && !this.uploadImage) {
        this.isEnableCrop = false
        this.$refs.modal.hide()
      } else if (evt.trigger === 'ok' && !this.$refs.cropper.getImageData()) {
        evt.preventDefault()
        // sweetAlertに
        this.$swal({
          title: $t('selectPictureStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (evt.trigger === 'ok' && this.$refs.cropper.getImageData()) {
        this.isImageUploading = true
        this.uploadResizedPhoto()
      }
    },
    uploadResizedPhoto () {
    //   console.log(this.myCroppa.generateBlob(blob))
      let userId = this.getUserId
      var date = moment()
      // var profileImageUrl = date.format('1+YYYY/MM/DD HH:mm') + '.jpg'
      // var profileImageUrl = (date / 1000) + '.jpg'
      // if (this.isEnableCrop) {}
      var profileImageUrl = (date / 1000) + '.' + this.fileInfo.type
      // console.log(profileImageUrl)
      const storageProfilePhotoRef = storage.ref('rtfb/' + userId)
      const path = profileImageUrl
      const photoImagesRef = storageProfilePhotoRef.child(path)
      // generateBlobで、画像からblobオブジェクトを作成します。
      // blobオブジェクトをそのままputメソッドで、Cloud Storageにアップしています。
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        photoImagesRef.put(blob)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              this.uploadImage = url
            })
            // const photoURL = snapshot.downloadURL
            // this.uploadImage = photoURL
          })
          .catch((err) => {
            console.log('upload error:', err)
          })
      })
    },
    onPictureSelected (e) {
      const file = e.target.files[0]
      this.hasCropperImage = true
      if (!file.type.includes('image/')) {
        this.hasCropperImage = false
        this.onFileTypeMismatch()
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          console.log('track:::onread')
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
          this.isLoaded = true
        }
        this.isEnableCrop = true
        this.fileInfo = file
        this.isLoaded = false
        reader.readAsDataURL(file)
      } else {
        this.onFileTypeMismatch()
      }
    },
    rotateImage (deg) {
      if (this.$refs.cropper) {
        this.$refs.cropper.rotate(deg)
      }
    },
    resetFlagForReset () {
      this.flagForReset = false
      this.$nextTick(function () {
        this.flagForReset = true
      })
    },
    senditem: function () {
      console.log('onClick senditem')
      const $t = this.$t
      if (this.$v.item.contentText.contentTextValidaiton) {
        if (this.uploadImage.length > 0) {
          this.item.uploadedFile = this.uploadImage
        }
        this.isRegistering = true
        // let replaceRouter = this.$router.push('/fb/list')
        let regist = this.setNewFbrequest
        let removeDraft = this.removeDraftsRtfbs
        let item = this.item
        let params = this.id
        var date = new Date()
        if (this.checkedUsers.length > 0) {
          this.item.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedUsers)
        }
        if (this.checkedGroups.length > 0 || this.checkedOrgs.length > 0) {
          let Groups = this.checkedGroups
          if (this.checkedOrgs.length > 0) {
            Groups = Groups.concat(this.checkedOrgs)
          }
          this.item.limitedAccess.limitedGroups = this.parseArrayToObject(Groups)
        }
        if (!params) {
          var createAt = date.getTime()
          item.createdAt = createAt / 1000
          console.log('in if', item)
          regist(item)
          // replaceRouter()
          if (this.checkDraft) {
            console.log('true')
            removeDraft(this.getUserId)
            this.checkDraft = false
          }
          this.$router.push('/fb/list')
        } else {
          var modifyAt = date.getTime()
          item.modifiedAt = modifyAt / 1000
          var editItem = {
            item: this.item,
            itemId: params
          }
          console.log('in else', editItem)
          regist(editItem)
          // replaceRouter()
          this.$router.push('/fb/list')
        }
      } else {
        this.$swal({
          title: $t('noDataStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    },
    cancelItem: function () {
      const $t = this.$t
      if (this.$v.item.contentText.contentTextValidaiton) {
        this.isRegistering = true
        let cancel = this.setDraftsRtfbs
        if (this.uploadImage) {
          this.item.uploadedFile = this.uploadImage
        }
        let item = this.item
        let params = this.id
        console.log(params)
        if (this.checkeUsers) {
          item.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedUsers)
        }
        if (this.checkedGroups) {
          item.limitedAccess.limitedGroups = this.parseArrayToObject(this.checkedGroups)
        }
        // console.log(Object.keys(this.getCurrentDraftRtfbs)[0])
        if (Object.keys(this.getCurrentDraftRtfbs).filter(x => !this.getCurrentDraftRtfbs[x] ? false : this.getCurrentDraftRtfbs[x].contentText).length > 0) {
          this.$swal({
            title: $t('popTitleStrType'),
            text: $t('popMessageStr2Type'),
            showCancelButton: true,
            cancelButtonColor: '#f64846',
            type: 'warning',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            reverseButtons: false,
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            allowOutsideClick: false,
            padding: '2rem'
            // timer: 3000
          }).then((result) => {
            if (result.value) {
              this.removeDraftsRtfbs(this.getUserId)
              console.log('true')
              var date = new Date()
              var createAt = date.getTime()
              item.createdAt = createAt / 1000
              cancel(item)
              this.$swal({
                title: $t('compStorageStr'),
                type: 'success',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
              this.$router.push('/fb/list')
            } else {
              console.log('false')
              this.$router.push('/fb/regist')
            }
          })
        } else {
          var date = new Date()
          var createAt = date.getTime()
          item.createdAt = createAt / 1000
          cancel(item)
          this.$swal({
            title: $t('compStorageStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
          this.$router.push('/fb/list')
        }
      } else {
        this.$swal({
          title: $t('noDataStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    },
    parseArrayToObject: function (array) {
      let obj = {}
      for (const i in array) {
        obj[array[i]] = 1
      }
      return obj
    },
    onClickCancel: function () {
      const $t = this.$t
      this.$swal({
        title: $t('popTitleStrType'),
        text: $t('confirmInputDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          this.$router.push('/fb/list')
        } else {
          console.log('false')
        }
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image-uploaded{
  color: #20a8d8;
}
.image-add{
  display: inline-block;
  float: right;
}
.isUpload{

}
</style>



// WEBPACK FOOTER //
// src/views/fb/FbRegist.vue